<template>
  <div 
  class="moow-master-container play-background"
  v-loading.fullscreen="loading" :element-loading-text="loadingText" element-loading-spinner="el-icon-loading">
    <nav-basic :progress="70" title=""></nav-basic>
    <div class="container">
      <b-row class="step-header">
        <p class="moow-header">Ordering, cover and caption of photos</p>
      </b-row>
      <b-row>
        <b-col class="pt-2 form-container amenities-form">
          <md-card class="island-card pr-3 pl-3">
            <md-card-content>
              <draggable v-model="marketingDet.images" :options="{group:'images'}" @start="drag=true" @end="drag=false">
                <div v-for="(file,id) in marketingDet.images" :key="id" class="mb-2 photo-uploded">
                  <div class="img-actions-container">
                    <div class="move-draggable-icon"></div>
                    <b-button @click="setCover(id)" class="set-as-cover">Set As Cover</b-button>
                    <div :id="id" class="hideCover">Cover photo</div>
                    <b-img :src="file.thumb" alt="Thumbnail" class="image" />
                  </div>
                  <div class="mt-2">
                    <b-form-input v-model="file.caption" style="border:none" placeholder="Caption..."></b-form-input>
                  </div>
                </div>
              </draggable>
            </md-card-content>
          </md-card>
          <b-row class="step-navigator-buttons">
            <b-col style="text-align:left;padding:0">
              <b-button @click="prev"  variant="outline-primary">Back</b-button>
            </b-col>
            <b-col style="text-align:right;padding:0">
              <b-button variant="primary" @click="next" class="btn-step-navigator">Next</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import {
    updateListingParts
  } from '../listingFunctions.js'
  let save = false
  import draggable from 'vuedraggable'
  export default {
    components: {
        draggable,
    },
    data() {
      return {
        loading: false,
        cover: '',
        loadingText: 'Saving...',
        coverSet: false
      };
    },
    created() {},
    computed: {
      genDet() {
        return this.$store.getters.genDet
      },
      marketingDet() {
        console.log('this.$store.getters.marketingDet:', this.$store.getters.marketingDet);
        
        return this.$store.getters.marketingDet
      }
    },
    mounted() {
      let idx = this.marketingDet.images.findIndex(file => {
        return file.cover == true
      })
      if (idx != -1) {
        document.getElementById(idx).classList.remove('hideCover')
        document.getElementById(idx).classList.add('showCover')
      }

    },
    methods: {
      leavePage(from, to){
        this.$store.dispatch('visitPage', from);
        this.$router.push({
          name: to
        })
      },
      prev() {
        this.$store.commit('UPDATE_MARKETINGDET', this.marketingDet)
        this.leavePage("SCENE1_1", "scene1")
      },
      next() {
        this.save()
        this.leavePage("SCENE1_1", "scene2")
      },
      saveAndExit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.save()
            this.leavePage('SCENE1_1', 'dashboard')
          } else {
            this.notifyError('Notification', 'Something is missing')
          }
        })
      },
      save(){
        if (!this.coverSet){
          this.setCover(0)
        }
        this.updateImagesInGenDetails()
        this.$store.commit('UPDATE_GENDET', this.genDet)
        this.$store.commit('UPDATE_MARKETINGDET', this.marketingDet)
        updateListingParts(this.createUpdateParts()).catch(err => {})
      },
      createUpdateParts(){
        return{
          'genDet': this.genDet,
          'marketingDet': this.marketingDet
        }
      },
      updateImagesInGenDetails(){
        var finalThumbs = []
        var finalOrigs = []
        for(var image of this.marketingDet.images){
          finalOrigs.push(image.url)
          finalThumbs.push(image.thumb)
        }
        this.genDet.thumbUrls = finalThumbs
        this.genDet.pictureUrls = finalOrigs
      },
      setCover(id) {
        for (let x = 0; x < this.marketingDet.images.length; x++) {
          var el = document.getElementById(x);
          if (x != id) {
            el.classList.remove('showCover')
            el.classList.add('hideCover')
          } else {
            el.classList.remove('hideCover')
            el.classList.add('showCover')
          }
        }
        for (let i = 0, j = this.marketingDet.images.length; i < j; i++) {
          this.marketingDet.images[i].cover = false
        }
        this.marketingDet.images[id].cover = true
        this.coverSet = true
      }
    }
  }

</script>
<style scoped>
  @import '../assets/styles/add-steps.css';
  @import '../assets/styles/global.css';
  @import '../assets/styles/images.css';

  photo-uploded{
    margin-left: 20px;
  }

  .img-actions-container {
    height: 135px;
    width: 180px;
    background-color: #f0efef;
  }




</style>



// WEBPACK FOOTER //
// src/components/scene1.1.vue